export default "__VITE_ASSET__b4e22f3b__"